import { XMLSerializer, DOMParser } from 'xmldom';

export function setAttributes(element, attributes) {
    const propNames = Object.getOwnPropertyNames(attributes);
    for (const name of propNames) {
        element.setAttribute(name, attributes[name]);
    }
}

export function createCandidateResponseNode(doc, values) {
    const elm = doc.createElement('candidateResponse');
    values.forEach((value) => {
        const valueElm = doc.createElement('value');
        const textNode = doc.createTextNode(value);
        valueElm.appendChild(textNode);
        elm.appendChild(valueElm);
    });

    return elm;
}

export function createRespVarElement(doc, data) {
    const elm = doc.createElement('responseVariable');
    const { identifier, cardinality, baseType } = data;
    const attribs = {
        identifier,
        cardinality,
        baseType,
    };

    if (data.choiceSequence) {
        attribs.choiceSequence = data.choiceSequence.join(' ');
    }

    setAttributes(elm, attribs);
    const candRespNode = createCandidateResponseNode(doc, data.userResponse);
    elm.appendChild(candRespNode);

    return elm;
}

export function createGeneralRespVarElement(doc, attributes, values) {
    const elm = doc.createElement('responseVariable');
    setAttributes(elm, attributes);
    const contentElm = createCandidateResponseNode(doc, values);
    elm.appendChild(contentElm);

    return elm;
}

export function stripUnwantedControlCharacters(itemResultString) {
    // eslint-disable-next-line no-control-regex
    return itemResultString.replace(/[\x00-\x08]/g, '');
}

const appendStudentHightlights = (doc, studentHighlights) => {
    appendAnnotations(doc, studentHighlights, 'studentHighlights');
};

const appendQuestionAnnotations = (doc, questionAnnotations) => {
    appendAnnotations(doc, questionAnnotations, 'questionAnnotations');
};

const appendAnnotations = (doc, data, nodeName) => {
    if (Array.isArray(data)) {
        const annotationsString = JSON.stringify(data);
        appendRespVarElement(doc, annotationsString, nodeName, 'single', 'string');
    }
};

const appendRespVarElement = (doc, dataString, identifier, cardinality, baseType) => {
    const respVarElement = createGeneralRespVarElement(
        doc,
        { identifier, cardinality, baseType },
        [dataString]
    );
    doc.firstChild.appendChild(respVarElement);
};

function serializeItemResult(itemResult) {
    const parser = new DOMParser();
    const serializer = new XMLSerializer();
    const doc = parser.parseFromString('<itemResult></itemResult>');
    const { identifier, sequenceIndex, datestamp, sessionStatus, studentHighlights,
        questionAnnotations, numAttempts, duration, responseIdentifiers } = itemResult;

    setAttributes(doc.firstChild, { identifier, sequenceIndex, datestamp, sessionStatus });

    appendRespVarElement(doc, numAttempts, 'numAttempts', 'single', 'integer');
    appendRespVarElement(doc, duration, 'duration', 'single', 'duration');
    appendStudentHightlights(doc, studentHighlights);
    appendQuestionAnnotations(doc, questionAnnotations);

    if (Array.isArray(responseIdentifiers)) {
        responseIdentifiers.forEach((item) => {
            const elm = createRespVarElement(doc, item);
            doc.firstChild.appendChild(elm);
        });
    }

    return stripUnwantedControlCharacters(serializer.serializeToString(doc));
}

export default serializeItemResult;
